import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const AssetNameCell = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
`

export const StackedCell = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`

export const PathRow = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;

    span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 220px;
        background-color: ${({ theme }) => theme.colors.greys[100]};
        padding: 2px 6px;
        border-radius: 4px;
    }
`

export const CopyIconWrapper = styled('span')`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
`
